import OriginTypography from './Typography';
import Text from './Text';
import Title from './Title';
import Paragraph from './Paragraph';
var Typography = OriginTypography;
Typography.Text = Text;
Typography.Title = Title;
Typography.Paragraph = Paragraph;
export default Typography;


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/typography/index.js
// module id = 827
// module chunks = 0